/* BirdDots preview interactions: no network, Shopify cart or checkout calls. */
(() => {
  'use strict';
  const storageKey = 'birddots-draft-events-v1';
  const allowedBundles = new Map([['Starter', 39], ['Home', 54], ['Whole View', 69]]);
  let events = [];
  try {
    const saved = JSON.parse(sessionStorage.getItem(storageKey) || '[]');
    if (Array.isArray(saved)) events = saved.filter((event) => event && typeof event.name === 'string' && typeof event.time === 'string').slice(-30);
  } catch (_) { /* In-memory tracking remains available if storage is unavailable. */ }

  function initialize(root) {
    if (!root || root.dataset.initialized === 'true') return;
    root.dataset.initialized = 'true';
    const find = (selector) => root.querySelector(selector);
    const dialog = find('#demo-dialog');
    const orderButton = find('#place-demo-order');
    const success = find('#demo-success');
    const eventList = find('#demo-events');
    let selection = null;
    let previousFocus = null;

    function renderEvents() {
      eventList.replaceChildren();
      const display = events.length ? events : [{ name: 'No demo events yet.', time: '' }];
      display.slice().reverse().forEach((event) => {
        const item = document.createElement('li');
        item.textContent = [event.time, event.name, event.bundle ? `Bundle: ${event.bundle}` : ''].filter(Boolean).join(' · ');
        eventList.append(item);
      });
    }

    function track(name, bundle) {
      const event = { name, time: new Date().toISOString() };
      if (allowedBundles.has(bundle)) event.bundle = bundle;
      events.push(event);
      events = events.slice(-30);
      try { sessionStorage.setItem(storageKey, JSON.stringify(events)); } catch (_) { /* Optional storage only. */ }
      renderEvents();
    }

    function closeDialog() {
      if (dialog.open) dialog.close();
    }

    root.querySelectorAll('[data-demo-bundle]').forEach((button) => {
      button.disabled = false;
      button.addEventListener('click', () => {
        const bundle = button.dataset.demoBundle;
        const price = allowedBundles.get(bundle);
        if (!price) return;
        selection = { bundle, price };
        previousFocus = button;
        find('#demo-bundle-name').textContent = `${bundle} · demo`;
        find('#demo-bundle-price').textContent = `$${price.toFixed(2)} USD`;
        const quantity = find('#demo-bundle-quantity');
        quantity.textContent = button.dataset.demoQuantity || quantity.dataset.quantityPending;
        orderButton.hidden = false;
        orderButton.disabled = false;
        success.hidden = true;
        dialog.showModal();
        document.body.classList.add('dialog-open');
        find('#close-demo').focus();
        track('demo_bundle_selected', bundle);
      });
    });

    find('#close-demo').addEventListener('click', closeDialog);
    find('#finish-demo').addEventListener('click', closeDialog);
    dialog.addEventListener('close', () => {
      document.body.classList.remove('dialog-open');
      if (previousFocus && previousFocus.isConnected) previousFocus.focus();
    });
    orderButton.addEventListener('click', () => {
      if (!selection || orderButton.disabled) return;
      orderButton.disabled = true;
      orderButton.hidden = true;
      success.hidden = false;
      track('demo_order_completed_not_a_sale', selection.bundle);
      find('#finish-demo').focus();
    });

    const calculate = find('#calculate-area');
    const widthInput = find('#glass-width');
    const heightInput = find('#glass-height');
    const countInput = find('#glass-count');
    const error = find('#area-error');
    const result = find('#area-result');
    const inputs = [widthInput, heightInput, countInput];
    inputs.forEach((input) => input.addEventListener('input', () => {
      result.hidden = true;
      error.hidden = true;
      input.removeAttribute('aria-invalid');
    }));
    calculate.disabled = false;
    calculate.addEventListener('click', () => {
      const width = Number(widthInput.value);
      const height = Number(heightInput.value);
      const count = Number(countInput.value);
      inputs.forEach((input) => input.removeAttribute('aria-invalid'));
      const problems = [];
      if (!Number.isFinite(width) || width < 1 || width > 240) problems.push(widthInput);
      if (!Number.isFinite(height) || height < 1 || height > 240) problems.push(heightInput);
      if (!Number.isInteger(count) || count < 1 || count > 20) problems.push(countInput);
      if (problems.length) {
        result.hidden = true;
        error.textContent = 'Enter width and height from 1 to 240 inches, and a whole number of windows from 1 to 20.';
        error.hidden = false;
        problems.forEach((input) => input.setAttribute('aria-invalid', 'true'));
        problems[0].focus();
        return;
      }
      const area = width * height * count / 144;
      error.hidden = true;
      find('#area-total').textContent = `${area.toLocaleString('en-US', { maximumFractionDigits: 1 })} sq ft of glass`;
      result.hidden = false;
      track('glass_area_estimated');
    });

    const clear = find('#clear-demo-events');
    clear.disabled = false;
    clear.addEventListener('click', () => {
      events = [];
      try { sessionStorage.removeItem(storageKey); } catch (_) { /* Optional storage only. */ }
      renderEvents();
    });
    root.querySelectorAll('[data-demo-track]').forEach((link) => link.addEventListener('click', () => track(link.dataset.demoTrack)));
    track('draft_preview_viewed');
  }

  document.querySelectorAll('[data-birddots-home]').forEach(initialize);
  document.addEventListener('shopify:section:load', (event) => {
    initialize(event.target.querySelector('[data-birddots-home]'));
  });
  document.addEventListener('shopify:section:unload', (event) => {
    if (event.target.querySelector('[data-birddots-home]')) document.body.classList.remove('dialog-open');
  });
})();
